import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Reusable hero block for inner pages. Cream-tinted, left-aligned, generous
 * spacing.
 */
export function PageHero({ eyebrow, eyebrowNode, h1, intro, breadcrumbs, actions }) {
  return (
    <section className="bg-wafa-cream/40" data-testid="page-hero">
      <div className="mx-auto max-w-5xl px-4 py-16 lg:px-6 lg:py-24">
        {breadcrumbs?.length ? (
          <nav className="mb-6 text-xs text-wafa-ink/60" aria-label="Breadcrumb">
            <ol className="flex flex-wrap items-center gap-1">
              {breadcrumbs.map((b, i) => (
                <li key={i} className="flex items-center gap-1">
                  {b.to ? (
                    <Link to={b.to} className="hover:text-wafa-deep">{b.label}</Link>
                  ) : (
                    <span className="text-wafa-deep">{b.label}</span>
                  )}
                  {i < breadcrumbs.length - 1 ? <ChevronRight className="h-3 w-3" /> : null}
                </li>
              ))}
            </ol>
          </nav>
        ) : null}
        {eyebrowNode ? (
          <div>{eyebrowNode}</div>
        ) : eyebrow ? (
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">
            {eyebrow}
          </div>
        ) : null}
        <h1 className="mt-3 font-heading text-4xl font-semibold leading-tight tracking-tight text-wafa-deep sm:text-5xl lg:text-6xl">
          {h1}
        </h1>
        {intro ? (
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
            {intro}
          </p>
        ) : null}
        {actions ? <div className="mt-8 flex flex-wrap gap-3">{actions}</div> : null}
      </div>
    </section>
  );
}
